<template>
  <div
    class="control-section pt-3"
    v-if="$security.checkUserAccess('ViewLandingPage')"
  >
    <ejs-dashboardlayout
      id="defaultLayout"
      ref="DashbordInstance"
      :cellSpacing="spacing"
      :columns="12"
      :allowResizing="allowResizing"
      :allowDragging="allowDragging"
    >
      <div
        id="widgeSliderPanel"
        class="widget-panel e-panel"
        data-row="0"
        data-col="0"
        data-sizeX="12"
        data-sizeY="3 "
        v-resize="onResize"
      >
        <div class="e-panel-container">
          <div class="text-align">
            <widget-slider :widgetHeight="widgetHeight" @resize="reizeEventHandler" />
          </div>
        </div>
      </div>
      <div
        v-if="this.$security.checkUserAccess('ViewAnnouncement')"
        id="eight1"
        class="widget-panel e-panel"
        data-row="4"
        data-col="0"
        data-sizeX="6"
        data-sizeY="0"
      >
        <div class="e-panel-container">
          <div class="text-align">
            <announcement></announcement>
          </div>
        </div>
      </div>
      <div
        id="eight2"
        class="widget-panel e-panel"
        data-row="4"
        :data-col="newsColumnSize"
        :data-sizeX="newsColumnSize === 6 ? 6 : 12"
        data-sizeY="0"
      >
        <div class="e-panel-container">
          <div class="text-align pb-4">
            <news-list v-if="companyNewsId" :companyId="companyNewsId" />
          </div>
        </div>
      </div>
    </ejs-dashboardlayout>
  </div>
</template>

<script>
import Vue from "vue";
import WidgetSlider from "./WidgetSlider.vue";
import { DashboardLayoutPlugin } from "@syncfusion/ej2-vue-layouts";
import Announcement from "./Announcement.vue";
import NewsList from "../dashboard/NewsList.vue";
import { mapActions, mapGetters } from "vuex";

Vue.use(DashboardLayoutPlugin);

export default {
  components: { WidgetSlider, Announcement, NewsList },
  name: "LandingPageHome",
  data() {
    return {
      widgetHeight: 300,
      allowResizing: false,
      allowDragging: false,
      count: 8,
      spacing: [20, 20],
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.reizeEventHandler);
  },
  computed: {
    ...gettersMap(),
    companyNewsId() {
      const newsId = this.tenantSettingTypes("companyNews");
      return newsId ? newsId[0] : null;
    },
    newsColumnSize() {
      return this.$security.checkUserAccess("ViewAnnouncement") ? 6 : 0;
    },
  },
  mounted() {
    window.addEventListener("resize", this.reizeEventHandler);
  },
  methods: {
    onResize,
    reizeEventHandler,
    getWidgetHeight,
    
  },
};

function reizeEventHandler() {
  this.getWidgetHeight();
}

function onResize() {
  this.widgetHeight = window.innerHeight * 0.45;
}

function getWidgetHeight() {
  const element = document.getElementById("widgeSliderPanel");
  if (element) {
    this.widgetHeight = element.offsetHeight;
  }
}

function gettersMap() {
  return mapGetters({
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}
</script>

<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-layouts/styles/material.css";

/* DashboardLayout element styles  */
#defaultLayout .e-panel .e-panel-container {
  vertical-align: middle;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
}

.panel-content {
  line-height: 80px;
}

#defaultLayout .e-panel {
  transition: none !important;
}
.e-dashboardlayout.e-control .e-panel {
  z-index: unset !important; /* we can remove it. this one is used for loader only*/
}

.widget-panel {
  background-color: white !important;
}
</style>